/**
 * API client for Ceetrix backend
 * Uses VITE_API_URL environment variable for environment-specific configuration
 */

import { config } from '../config';

const API_URL = config.apiUrl;

/** HTTP status code for unauthorized requests */
const HTTP_UNAUTHORIZED = 401;

export const api = {
  /**
   * Base URL for API requests
   * Set via VITE_API_URL — see wrangler.toml.example for domain values
   */
  baseUrl: API_URL,

  /**
   * Make authenticated API request
   * Includes credentials (session cookie) with all requests
   * Redirects to sign-in page on auth failure (401)
   */
  async fetch(endpoint: string, options: RequestInit = {}) {
    const url = `${API_URL}${endpoint}`;
    const response = await fetch(url, {
      ...options,
      credentials: 'include', // Send session cookie
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      // Auth expired or invalid - redirect to sign-in
      if (response.status === HTTP_UNAUTHORIZED) {
        window.location.href = '/signin';
        // Return a never-resolving promise to prevent further execution
        return new Promise(() => {});
      }
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },
};
